module.exports = __webpack_public_path__ + "static/media/blog_1.6d3440b8.jpg";